var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 668,
    height: 668,
    viewBox: "0 0 668 668",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M334 0.666687C150.2 0.666687 0.666687 150.2 0.666687 334V472.1C0.666687 506.233 30.5667 534 67.3334 534H100.667C109.507 534 117.986 530.488 124.237 524.237C130.488 517.986 134 509.507 134 500.667V329.233C134 320.393 130.488 311.914 124.237 305.663C117.986 299.412 109.507 295.9 100.667 295.9H70.4C88.9334 166.9 199.933 67.3334 334 67.3334C468.067 67.3334 579.067 166.9 597.6 295.9H567.333C558.493 295.9 550.014 299.412 543.763 305.663C537.512 311.914 534 320.393 534 329.233V534C534 570.767 504.1 600.667 467.333 600.667H400.667V567.333H267.333V667.333H467.333C540.867 667.333 600.667 607.533 600.667 534C637.433 534 667.333 506.233 667.333 472.1V334C667.333 150.2 517.8 0.666687 334 0.666687Z",
    fill: "#0066FF",
    stroke: "#0066FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueSupport);
export default __webpack_public_path__ + "static/media/blue_support.e69ad73ec57bffc15786b02ed3a47cdc.svg";
export { ForwardRef as ReactComponent };